/* You Fly LA — page-body modules (v39, 2026-09-23). assets/yfla-mods.js, styled by assets/yfla-mods.css.
   Loaded with defer from snippets/yfla-runway-head.liquid on every page.

   WHAT THIS IS
   Progressive enhancement for plain HTML written into page bodies. Every pattern below reads correctly with
   JavaScript off (and on the live theme, which does not load this file); with it on, the pattern becomes an
   interactive widget. All original content stays in the DOM, so it stays indexable.

   THE CONTRACT (content/GUIDE.md "Interactive modules" — content writers depend on these exact names):
     ul|ol[data-yfla-mod="checklist"]  data-title, data-cta-label, data-cta-url, data-low, data-mid, data-high;
                                       li[data-weight] (default 1). Checkbox rows, a weighted progress meter,
                                       a verdict (low below 50%, mid 50-84%, high 85% and up), the CTA, Reset.
     table[data-yfla-mod="hours"]      body rows tr[data-min]; data-cta-label, data-cta-url. A "Your Hours"
                                       input and bar per row, a summary row, the CTA; cards below 600px.
     ol[data-yfla-mod="steps"]         li > h3 + p (+ img); data-cta-label, data-cta-url. One step at a time.
     table[data-yfla-mod="compare"]    600px and up: sticky first column, zebra rows. Below 600px: one data
                                       column at a time, chosen with a segmented control.
     ol[data-yfla-mod="quiz"]          li[data-answer="n"] (1-based) > p + ul (+ p.yfla-why); data-cta-label,
                                       data-cta-url. One question at a time, then the score.
     div[data-yfla-mod="aircraft"]     A fleet picker built from window.YFLA_FLEET (snippets/yfla-fleet-data)
                                       and window.YFLA (snippets/yfla-data). Nothing is typed here.

   RULES THIS FILE KEEPS: idempotent (data-ym-ready on each element); runs on DOMContentLoaded and again for
   content added later (MutationObserver); no network request of any kind; localStorage only for checklist
   ticks and hours values, keyed by location.pathname + the widget's index, always inside try/catch.
   A widget that throws is marked data-ym-ready="error" and left as plain content.

   ALSO HERE: the cost calculator's pinned Total/Monthly/Timeline strip (/pages/flight-training-cost-
   calculator, sections/yfla-calculator.liquid, styled in assets/yfla-tools.css). Below 760px it is shown
   only once the first control has scrolled clear of it, so it never covers the rating dropdown on first
   load. See calcStrip() and the matching block in assets/yfla-mods.css. */
(function () {
  'use strict';
  if (window.YFLAMods) return;
  var M = window.YFLAMods = { version: '1.0' };
  var seq = 0;

  /* ------------------------------------------------------------------ helpers */
  function uid(p) { seq += 1; return 'ym-' + p + '-' + seq; }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function kids(node, tags) {
    return Array.prototype.filter.call(node.children, function (c) { return tags.indexOf(c.tagName) >= 0; });
  }
  function mk(tag, cls, txt) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  }
  function button(cls, txt) { var b = mk('button', cls, txt); b.type = 'button'; return b; }
  function text(node) { return node ? String(node.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function money(n) { return '$' + Number(n).toLocaleString('en-US'); }
  function one(n) { return (Math.round(n * 10) / 10).toLocaleString('en-US', { maximumFractionDigits: 1 }); }
  function level(p) { return p >= 85 ? 'high' : (p >= 50 ? 'mid' : 'low'); }
  function calm() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }
  function safeHref(u) {
    u = String(u || '').trim();
    return /^(\/(?!\/)|#|tel:|mailto:|https:\/\/)/i.test(u) ? u : '';
  }
  /* The widget's CTA from data-cta-label / data-cta-url; the site's consultation CTA when either is missing. */
  function cta(node) {
    var href = safeHref(node.getAttribute('data-cta-url'));
    var label = String(node.getAttribute('data-cta-label') || '').trim();
    if (!href || !label) { href = '/products/book-a-consultation'; label = 'Book A Free Consultation'; }
    var a = mk('a', 'ym-btn ym-btn-primary', label);
    a.setAttribute('href', href);
    return a;
  }
  function headBlock(eyebrow, title) {
    var h = mk('div', 'ym-head');
    h.appendChild(mk('span', 'ym-eyebrow', eyebrow));
    var t = mk('p', 'ym-title', title);
    t.id = uid('t');
    h.appendChild(t);
    return h;
  }
  /* Wrap `node` (or the table wrappers around it, when they hold nothing else) in `root`. */
  function wrapIn(root, node) {
    var outer = node;
    while (outer.parentElement && outer.parentElement.children.length === 1 &&
           /(^|\s)(yfla-table-wrap|rte-table-wrapper)(\s|$)/.test(outer.parentElement.className)) {
      outer = outer.parentElement;
    }
    outer.parentNode.insertBefore(root, outer);
    root.appendChild(outer);
    return outer;
  }
  var store = {
    get: function (k) {
      try { var v = window.localStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; }
    },
    set: function (k, v) {
      try { window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* storage blocked or full */ }
    },
    drop: function (k) {
      try { window.localStorage.removeItem(k); } catch (e) { /* storage blocked */ }
    }
  };
  function storeKey(node, type) {
    return 'yfla-mods:' + location.pathname + ':' + type + ':' + qsa('[data-yfla-mod="' + type + '"]').indexOf(node);
  }
  /* Height of the stuck site header (#header-group is sticky with a negative top), so a sticky meter sits
     under it rather than behind it. */
  function stickyTop() {
    var hg = document.getElementById('header-group');
    if (!hg) return 0;
    var cs = window.getComputedStyle(hg);
    if (cs.position !== 'sticky' && cs.position !== 'fixed') return 0;
    return Math.max(0, Math.round(hg.getBoundingClientRect().height + (parseFloat(cs.top) || 0)));
  }

  /* ------------------------------------------------------------------ 1. checklist */
  function checklist(list) {
    var items = kids(list, ['LI']);
    if (!items.length) return;
    var key = storeKey(list, 'checklist');
    var saved = store.get(key) || [];
    var msgs = {
      low: list.getAttribute('data-low') || 'Not yet. Work through the unticked items first.',
      mid: list.getAttribute('data-mid') || 'Getting close. A few items are left.',
      high: list.getAttribute('data-high') || 'You look ready.'
    };
    var root = mk('div', 'ym ym-check');
    var head = headBlock('Checklist', list.getAttribute('data-title') || 'Checklist');
    root.setAttribute('role', 'group');
    root.setAttribute('aria-labelledby', head.lastChild.id);
    var meter = mk('div', 'ym-meter');
    var row = mk('div', 'ym-meter-row');
    var count = mk('p', 'ym-count');
    var pct = mk('span', 'ym-pct');
    row.appendChild(count);
    row.appendChild(pct);
    var bar = mk('div', 'ym-bar');
    bar.setAttribute('role', 'progressbar');
    bar.setAttribute('aria-valuemin', '0');
    bar.setAttribute('aria-valuemax', '100');
    bar.setAttribute('aria-label', 'Readiness');
    var fill = mk('i');
    bar.appendChild(fill);
    meter.appendChild(row);
    meter.appendChild(bar);
    var verdict = mk('p', 'ym-verdict');
    verdict.setAttribute('aria-live', 'polite');
    var actions = mk('div', 'ym-actions');
    actions.appendChild(cta(list));
    var reset = button('ym-reset', 'Reset');
    actions.appendChild(reset);

    list.parentNode.insertBefore(root, list);
    root.appendChild(head);
    root.appendChild(meter);
    root.appendChild(list);
    root.appendChild(verdict);
    root.appendChild(actions);
    list.classList.add('ym-list');
    list.setAttribute('role', 'list');

    var weights = [];
    var boxes = items.map(function (li, i) {
      var w = parseFloat(li.getAttribute('data-weight'));
      weights.push(w > 0 ? w : 1);
      var cb = mk('input', 'ym-cb');
      cb.type = 'checkbox';
      cb.id = uid('c');
      cb.checked = !!saved[i];
      var label = mk('label', 'ym-item');
      label.setAttribute('for', cb.id);
      var span = mk('span', 'ym-text');
      while (li.firstChild) span.appendChild(li.firstChild);
      label.appendChild(cb);
      label.appendChild(span);
      li.appendChild(label);
      return cb;
    });

    function update(save) {
      var total = 0, done = 0, n = 0;
      boxes.forEach(function (cb, i) {
        total += weights[i];
        if (cb.checked) { done += weights[i]; n += 1; }
        items[i].classList.toggle('ym-on', cb.checked);
      });
      var p = total ? Math.round(done / total * 100) : 0;
      var lv = level(p);
      count.textContent = n + ' Of ' + boxes.length + ' Ready';
      pct.textContent = p + '%';
      fill.style.width = p + '%';
      bar.setAttribute('aria-valuenow', String(p));
      bar.setAttribute('aria-valuetext', count.textContent + ', ' + p + '%');
      root.setAttribute('data-level', lv);
      if (verdict.getAttribute('data-level') !== lv) {
        verdict.setAttribute('data-level', lv);
        verdict.textContent = msgs[lv];
      }
      if (save) store.set(key, boxes.map(function (cb) { return cb.checked ? 1 : 0; }));
    }
    list.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('ym-cb')) update(true);
    });
    reset.addEventListener('click', function () {
      boxes.forEach(function (cb) { cb.checked = false; });
      store.drop(key);
      update(false);
    });
    root.style.setProperty('--ym-top', stickyTop() + 'px');
    update(false);
  }

  /* ------------------------------------------------------------------ 2. hours tracker */
  function hours(table) {
    var body = table.tBodies[0];
    if (!body) return;
    var rows = Array.prototype.slice.call(body.rows);
    var need = rows.filter(function (r) { return r.hasAttribute('data-min'); });
    if (!need.length) return;
    var key = storeKey(table, 'hours');
    var saved = store.get(key) || [];
    var headRow = table.tHead && table.tHead.rows.length ? table.tHead.rows[table.tHead.rows.length - 1] : null;
    var labels = headRow ? Array.prototype.map.call(headRow.cells, text) : [];

    var root = mk('div', 'ym ym-hours');
    wrapIn(root, table);
    table.classList.add('ym-hours-t');
    if (headRow) {
      var th = mk('th', 'ym-hcol', 'Your Hours');
      th.setAttribute('scope', 'col');
      headRow.appendChild(th);
    }
    var cols = 1;
    rows.forEach(function (r) {
      Array.prototype.forEach.call(r.cells, function (c, i) {
        if (i > 0 && labels[i]) c.setAttribute('data-ym-label', labels[i]);
      });
      cols = Math.max(cols, r.cells.length + 1);
    });
    var totalRow = null;
    need.forEach(function (r) { if (!totalRow && /\btotal\b/i.test(text(r.cells[0]))) totalRow = r; });

    var fields = [];
    rows.forEach(function (r) {
      var td = mk('td', 'ym-hcell');
      r.appendChild(td);
      if (!r.hasAttribute('data-min')) return;
      var min = parseFloat(r.getAttribute('data-min')) || 0;
      var name = text(r.cells[0]);
      var inp = mk('input', 'ym-num');
      inp.type = 'number';
      inp.id = uid('h');
      inp.min = '0';
      inp.step = 'any';
      inp.placeholder = '0';
      inp.setAttribute('inputmode', 'decimal');
      inp.setAttribute('aria-label', 'Your hours: ' + name + ' (minimum ' + one(min) + ')');
      var lab = mk('label', 'ym-hlabel', 'Your Hours');
      lab.setAttribute('for', inp.id);
      var stat = mk('span', 'ym-hstat');
      var line = mk('span', 'ym-hline');
      line.appendChild(inp);
      line.appendChild(stat);
      var hbar = mk('span', 'ym-hbar');
      hbar.setAttribute('aria-hidden', 'true');
      var hfill = mk('i');
      hbar.appendChild(hfill);
      td.appendChild(lab);
      td.appendChild(line);
      td.appendChild(hbar);
      var v = saved[fields.length];
      if (v != null && v !== '') inp.value = v;
      fields.push({ row: r, inp: inp, min: min, stat: stat, fill: hfill });
    });

    var foot = table.tFoot || table.createTFoot();
    var sumRow = foot.insertRow(-1);
    sumRow.className = 'ym-hsum';
    var sumCell = mk('td');
    sumCell.colSpan = cols;
    var sum = mk('p', 'ym-hsum-text');
    sum.setAttribute('aria-live', 'polite');
    var sbar = mk('span', 'ym-bar');
    sbar.setAttribute('aria-hidden', 'true');
    var sfill = mk('i');
    sbar.appendChild(sfill);
    sumCell.appendChild(sum);
    sumCell.appendChild(sbar);
    sumRow.appendChild(sumCell);

    var actions = mk('div', 'ym-actions');
    actions.appendChild(cta(table));
    var reset = button('ym-reset', 'Clear My Hours');
    actions.appendChild(reset);
    root.appendChild(actions);

    function val(f) { var v = parseFloat(f.inp.value); return v > 0 ? v : 0; }
    function update(save) {
      var met = 0;
      fields.forEach(function (f) {
        var v = val(f);
        var raw = parseFloat(f.inp.value);
        if (raw < 0) f.inp.setAttribute('aria-invalid', 'true'); else f.inp.removeAttribute('aria-invalid');
        var ok = v >= f.min && (f.min > 0 || v > 0);
        var p = f.min > 0 ? Math.min(100, v / f.min * 100) : (v > 0 ? 100 : 0);
        f.fill.style.width = p + '%';
        f.row.classList.toggle('ym-met', ok);
        f.stat.textContent = (ok ? '✓ ' : '') + one(v) + ' Of ' + one(f.min);
        if (ok) met += 1;
      });
      var t = met + ' Of ' + fields.length + ' Requirements Met';
      if (totalRow) {
        var tf = fields.filter(function (f) { return f.row === totalRow; })[0];
        if (tf) t += ' · ' + one(val(tf)) + ' Of ' + one(tf.min) + ' Total';
      }
      sum.textContent = t;
      sfill.style.width = (fields.length ? met / fields.length * 100 : 0) + '%';
      if (save) store.set(key, fields.map(function (f) { return f.inp.value; }));
    }
    table.addEventListener('input', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('ym-num')) update(true);
    });
    reset.addEventListener('click', function () {
      fields.forEach(function (f) { f.inp.value = ''; });
      store.drop(key);
      update(false);
    });
    update(false);
  }

  /* ------------------------------------------------------------------ 3. step-through */
  function steps(ol) {
    var slides = kids(ol, ['LI']);
    var n = slides.length;
    if (!n) return;
    var root = mk('div', 'ym ym-steps');
    root.setAttribute('role', 'region');
    root.setAttribute('aria-roledescription', 'carousel');
    root.setAttribute('aria-label', ol.getAttribute('data-title') || 'Step By Step');
    var top = mk('div', 'ym-steps-top');
    var count = mk('p', 'ym-steps-count');
    count.setAttribute('aria-live', 'polite');
    top.appendChild(count);
    ol.parentNode.insertBefore(root, ol);
    root.appendChild(top);
    root.appendChild(ol);
    ol.classList.add('ym-track');
    ol.setAttribute('tabindex', '0');
    ol.setAttribute('aria-label', n + ' steps. Use the arrow keys or swipe.');
    slides.forEach(function (li) { li.classList.add('ym-slide'); });
    var ctaP = mk('p', 'ym-slide-cta');
    ctaP.appendChild(cta(ol));
    slides[n - 1].appendChild(ctaP);

    var nav = mk('div', 'ym-steps-nav');
    var prev = button('ym-btn ym-btn-ghost ym-prev');
    var prevIcon = mk('span', '', '←');
    prevIcon.setAttribute('aria-hidden', 'true');
    prev.appendChild(prevIcon);
    prev.appendChild(document.createTextNode(' Back'));
    var next = button('ym-btn ym-btn-dark ym-next');
    next.appendChild(document.createTextNode('Next '));
    var nextIcon = mk('span', '', '→');
    nextIcon.setAttribute('aria-hidden', 'true');
    next.appendChild(nextIcon);
    var dots = mk('div', 'ym-dots');
    var dotBtns = slides.map(function (li, i) {
      var d = button('ym-dot');
      d.setAttribute('aria-label', 'Step ' + (i + 1) + ' Of ' + n);
      d.appendChild(mk('span'));
      d.addEventListener('click', function () { go(i); });
      dots.appendChild(d);
      return d;
    });
    nav.appendChild(prev);
    nav.appendChild(dots);
    nav.appendChild(next);
    root.appendChild(nav);

    var cur = 0, settleTimer = 0, drag = null;
    function base() { return slides[0].offsetLeft; }
    function paint() {
      count.textContent = 'Step ' + (cur + 1) + ' Of ' + n;
      dotBtns.forEach(function (d, i) {
        if (i === cur) d.setAttribute('aria-current', 'step'); else d.removeAttribute('aria-current');
      });
      prev.setAttribute('aria-disabled', cur === 0 ? 'true' : 'false');
      next.setAttribute('aria-disabled', cur === n - 1 ? 'true' : 'false');
      slides.forEach(function (li, i) { li.classList.toggle('ym-cur', i === cur); });
    }
    function go(i, instant) {
      cur = Math.max(0, Math.min(n - 1, i));
      paint();
      var left = slides[cur].offsetLeft - base();
      if (typeof ol.scrollTo === 'function') {
        ol.scrollTo({ left: left, behavior: (instant || calm()) ? 'auto' : 'smooth' });
      } else {
        ol.scrollLeft = left;
      }
    }
    function nearest() {
      var x = ol.scrollLeft, b = base(), best = 0, dist = Infinity;
      slides.forEach(function (li, i) {
        var d = Math.abs(li.offsetLeft - b - x);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    }
    ol.addEventListener('scroll', function () {
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(function () {
        if (drag) return;
        var i = nearest();
        if (i !== cur) { cur = i; paint(); }
      }, 120);
    }, { passive: true });
    prev.addEventListener('click', function () { if (cur > 0) go(cur - 1); });
    next.addEventListener('click', function () { if (cur < n - 1) go(cur + 1); });
    root.addEventListener('keydown', function (e) {
      if (e.target && e.target.closest && e.target.closest('input, textarea, select')) return;
      var k = e.key;
      if (k === 'ArrowRight' || k === 'ArrowLeft' || k === 'Home' || k === 'End') {
        e.preventDefault();
        go(k === 'Home' ? 0 : (k === 'End' ? n - 1 : cur + (k === 'ArrowRight' ? 1 : -1)));
      }
    });
    /* Mouse drag (touch uses the native scroll-snap swipe). */
    ol.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest && e.target.closest('a, button, input, select, textarea, label')) return;
      drag = { x: e.clientX, left: ol.scrollLeft, moved: false };
      try { ol.setPointerCapture(e.pointerId); } catch (err) { /* not capturable */ }
      ol.classList.add('ym-drag');
    });
    ol.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (Math.abs(dx) > 4) drag.moved = true;
      ol.scrollLeft = drag.left - dx;
    });
    function endDrag(e) {
      if (!drag) return;
      var dx = e.clientX - drag.x, moved = drag.moved;
      drag = null;
      ol.classList.remove('ym-drag');
      if (!moved) return;
      ol.setAttribute('data-ym-dragged', '1');
      window.setTimeout(function () { ol.removeAttribute('data-ym-dragged'); }, 0);
      go(Math.abs(dx) > 40 ? cur + (dx < 0 ? 1 : -1) : cur);
    }
    ol.addEventListener('pointerup', endDrag);
    ol.addEventListener('pointercancel', endDrag);
    ol.addEventListener('click', function (e) {
      if (ol.getAttribute('data-ym-dragged') === '1') { e.preventDefault(); ol.removeAttribute('data-ym-dragged'); }
    }, true);
    window.addEventListener('resize', function () { go(cur, true); });
    paint();
  }

  /* ------------------------------------------------------------------ 4. compare */
  function compare(table) {
    var headRow = table.tHead && table.tHead.rows.length ? table.tHead.rows[table.tHead.rows.length - 1] : table.rows[0];
    if (!headRow) return;
    var heads = Array.prototype.map.call(headRow.cells, text);
    var root = mk('div', 'ym ym-cmp');
    var outer = wrapIn(root, table);
    table.classList.add('ym-cmp-t');
    if (!table.id) table.id = uid('cmp');
    if (heads.length < 3) return;
    var seg = mk('div', 'ym-seg');
    seg.setAttribute('role', 'group');
    seg.setAttribute('aria-label', 'Choose a column to compare');
    var btns = [];
    heads.forEach(function (h, col) {
      if (col === 0) return;
      var b = button('ym-seg-btn', h || ('Column ' + (col + 1)));
      b.setAttribute('aria-controls', table.id);
      b.addEventListener('click', function () { pick(col); });
      btns.push(b);
      seg.appendChild(b);
    });
    root.insertBefore(seg, outer);
    function pick(col) {
      table.setAttribute('data-ym-col', String(col + 1));
      btns.forEach(function (b, i) { b.setAttribute('aria-pressed', i + 1 === col ? 'true' : 'false'); });
    }
    pick(1);
  }

  /* ------------------------------------------------------------------ 5. quiz */
  function quiz(ol) {
    var qs = kids(ol, ['LI']).filter(function (li) { return kids(li, ['UL', 'OL']).length; });
    var n = qs.length;
    if (!n) return;
    var letters = 'ABCDEFGHIJ';
    var msgs = {
      low: ol.getAttribute('data-low') || 'Worth another look. Try again and read each explanation.',
      mid: ol.getAttribute('data-mid') || 'A solid start. The explanations cover the ones you missed.',
      high: ol.getAttribute('data-high') || 'Nicely done. You know this material.'
    };
    var root = mk('div', 'ym ym-quiz');
    root.setAttribute('role', 'group');
    root.setAttribute('aria-label', ol.getAttribute('data-title') || 'Quick Quiz');
    var top = mk('div', 'ym-qtop');
    top.appendChild(mk('span', 'ym-eyebrow', 'Quick Quiz'));
    var count = mk('span', 'ym-qcount');
    top.appendChild(count);
    ol.parentNode.insertBefore(root, ol);
    root.appendChild(top);
    root.appendChild(ol);
    ol.classList.add('ym-qlist');

    var state = qs.map(function (li, qi) {
      li.classList.add('ym-q');
      var optList = kids(li, ['UL', 'OL'])[0];
      var q = kids(li, ['P']).filter(function (p) { return !p.classList.contains('yfla-why'); })[0] || null;
      if (q) { q.classList.add('ym-qtext'); q.setAttribute('tabindex', '-1'); }
      var why = kids(li, ['P', 'DIV']).filter(function (p) { return p.classList.contains('yfla-why'); })[0] || null;
      optList.classList.add('ym-opts');
      optList.setAttribute('role', 'list');
      var opts = kids(optList, ['LI']);
      var s = { li: li, q: q, why: why, ans: parseInt(li.getAttribute('data-answer'), 10) - 1, chosen: -1, opts: opts };
      s.btns = opts.map(function (o, oi) {
        var b = button('ym-opt');
        var keyTag = mk('span', 'ym-opt-key', letters.charAt(oi) || String(oi + 1));
        keyTag.setAttribute('aria-hidden', 'true');
        var t = mk('span', 'ym-opt-text');
        while (o.firstChild) t.appendChild(o.firstChild);
        var mark = mk('span', 'ym-opt-mark');
        b.appendChild(keyTag);
        b.appendChild(t);
        b.appendChild(mark);
        o.appendChild(b);
        b.addEventListener('click', function () { choose(qi, oi); });
        return b;
      });
      s.fb = mk('p', 'ym-feedback');
      s.fb.setAttribute('role', 'status');
      optList.parentNode.insertBefore(s.fb, optList.nextSibling);
      s.next = button('ym-btn ym-btn-dark ym-qnext', qi === n - 1 ? 'See Your Score' : 'Next Question');
      s.next.hidden = true;
      s.next.addEventListener('click', function () { if (qi === n - 1) finish(); else show(qi + 1, true); });
      li.appendChild(s.next);
      return s;
    });

    var end = mk('div', 'ym-qend');
    end.hidden = true;
    end.appendChild(mk('span', 'ym-eyebrow', 'Your Score'));
    var score = mk('p', 'ym-score');
    score.setAttribute('tabindex', '-1');
    var msg = mk('p', 'ym-qmsg');
    var actions = mk('div', 'ym-actions');
    actions.appendChild(cta(ol));
    var retry = button('ym-reset', 'Try Again');
    actions.appendChild(retry);
    end.appendChild(score);
    end.appendChild(msg);
    end.appendChild(actions);
    root.appendChild(end);

    function show(i, focus) {
      state.forEach(function (s, k) { s.li.classList.toggle('ym-q-off', k !== i); });
      end.hidden = true;
      count.textContent = 'Question ' + (i + 1) + ' Of ' + n;
      if (focus && state[i].q) state[i].q.focus();
    }
    function choose(qi, oi) {
      var s = state[qi];
      if (s.chosen >= 0) return;
      s.chosen = oi;
      var valid = s.ans >= 0 && s.ans < s.btns.length;
      s.li.classList.add('ym-answered');
      s.btns.forEach(function (b, i) {
        b.disabled = true;
        var mark = b.lastChild;
        if (valid && i === s.ans) {
          b.classList.add('ym-right');
          mark.textContent = '✓';
          mark.setAttribute('aria-label', 'Correct answer');
        } else if (i === oi) {
          b.classList.add('ym-wrong');
          mark.textContent = '✗';
          mark.setAttribute('aria-label', 'Your answer');
        }
      });
      var right = valid && oi === s.ans;
      if (!valid) s.fb.textContent = 'Answer noted.';
      else if (right) s.fb.textContent = 'Correct.';
      else s.fb.textContent = 'Not quite. The answer is ' + letters.charAt(s.ans) + ': ' + text(s.btns[s.ans].children[1]) + '.';
      s.fb.className = 'ym-feedback ' + (right ? 'ym-fb-right' : 'ym-fb-wrong');
      if (s.why) s.why.classList.add('ym-why-on');
      s.next.hidden = false;
      s.next.focus();
    }
    function finish() {
      var right = state.filter(function (s) { return s.chosen === s.ans; }).length;
      state.forEach(function (s) { s.li.classList.add('ym-q-off'); });
      score.textContent = right + ' Of ' + n;
      msg.textContent = msgs[level(right / n * 100)];
      count.textContent = 'Done';
      end.hidden = false;
      score.focus();
    }
    retry.addEventListener('click', function () {
      state.forEach(function (s) {
        s.chosen = -1;
        s.li.classList.remove('ym-answered');
        s.btns.forEach(function (b) {
          b.disabled = false;
          b.classList.remove('ym-right', 'ym-wrong');
          b.lastChild.textContent = '';
          b.lastChild.removeAttribute('aria-label');
        });
        s.fb.textContent = '';
        s.fb.className = 'ym-feedback';
        if (s.why) s.why.classList.remove('ym-why-on');
        s.next.hidden = true;
      });
      show(0, true);
    });
    show(0, false);
  }

  /* ------------------------------------------------------------------ 6. aircraft picker */
  function aircraft(div) {
    var Y = window.YFLA || {};
    var fleet = (window.YFLA_FLEET || []).filter(function (f) { return f && spec(f, 'Seats'); });
    if (!fleet.length) return;
    var products = (Y.discovery && Y.discovery.products) || {};
    var assets = window.YFLA_ASSETS || {};
    var MAIN = 'discovery-flight-los-angeles';

    function spec(f, name) {
      var s = (f.specs || []).filter(function (x) { return x[0] === name; })[0];
      return s ? s[1] : '';
    }
    function productFor(handle) {
      var hit = null;
      Object.keys(products).some(function (k) {
        var p = products[k];
        var d = (p.durations || []).filter(function (x) { return x[2] === handle; })[0];
        if (d) { hit = { p: p, price: d[1] }; return true; }
        return false;
      });
      return hit;
    }
    function mentions(f, str) {
      str = String(str || '').toLowerCase();
      return String(f.name || '').split(/\s+/).some(function (t) { return t.length > 3 && str.indexOf(t.toLowerCase()) >= 0; });
    }
    function weightLimit(f) {
      var hit = f.disc ? productFor(f.disc) : null;
      return hit && hit.p.weight && mentions(f, hit.p.aircraft) ? hit.p.weight : '';
    }
    function packageRate(f) {
      var out = '';
      var standard = /standard/i.test(f.rate || '');
      (Y.programs || []).some(function (prog) {
        return (prog.packages || []).some(function (pk) {
          return (pk.rows || []).some(function (r) {
            var byName = r[0] === f.name;
            var byStandard = standard && /^Single-Engine Aircraft$/.test(r[0]);
            if ((byName || byStandard) && /\$/.test(r[2] || '')) {
              out = r[2] + ' · ' + prog.tab + ' ' + pk.name;
              return true;
            }
            return false;
          });
        });
      });
      return out;
    }
    function img(f) {
      var k = (f.imgs || [])[0];
      var u = k && assets[k] ? String(assets[k]) : '';
      return u.replace('_1600x.', '_800x.');
    }
    function shortName(f) { return String(f.name || '').split(/\s+/).slice(0, 2).join(' '); }

    var main = productFor(MAIN);
    var mainLabel = 'Book A Discovery Flight' + (main ? ' · ' + money(main.price) : '');
    /* Opens on data-default="<fleet id>" if given, else on the aircraft the $229 discovery flight flies. */
    var start = -1;
    var want = div.getAttribute('data-default');
    fleet.forEach(function (f, i) { if (start < 0 && want && f.id === want) start = i; });
    fleet.forEach(function (f, i) { if (start < 0 && main && mentions(f, main.p.aircraft)) start = i; });
    if (start < 0) start = 0;

    var root = mk('div', 'ym ym-air');
    var head = headBlock('Our Fleet', div.getAttribute('data-title') || 'Pick An Aircraft');
    root.setAttribute('role', 'group');
    root.setAttribute('aria-labelledby', head.lastChild.id);
    var panelId = uid('air');
    var seg = mk('div', 'ym-seg ym-air-seg');
    seg.setAttribute('role', 'group');
    seg.setAttribute('aria-label', 'Choose an aircraft');
    var panel = mk('div', 'ym-air-panel');
    panel.id = panelId;
    var actions = mk('div', 'ym-actions');
    var book = mk('a', 'ym-btn ym-btn-primary', mainLabel);
    book.setAttribute('href', '/products/' + MAIN);
    actions.appendChild(book);
    var btns = fleet.map(function (f, i) {
      var b = button('ym-seg-btn', shortName(f));
      b.setAttribute('aria-controls', panelId);
      b.addEventListener('click', function () { pick(i); });
      seg.appendChild(b);
      return b;
    });
    root.appendChild(head);
    root.appendChild(seg);
    root.appendChild(panel);
    root.appendChild(actions);
    div.appendChild(root);

    function row(dl, dt, dd) {
      if (!dd) return;
      dl.appendChild(mk('dt', '', dt));
      dl.appendChild(mk('dd', '', dd));
    }
    function chip(href, label) {
      var a = mk('a', 'ym-chip', label);
      a.setAttribute('href', href);
      return a;
    }
    function pick(i) {
      var f = fleet[i];
      btns.forEach(function (b, k) { b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      panel.textContent = '';
      var media = mk('div', 'ym-air-media');
      var src = img(f);
      if (src) {
        var im = mk('img');
        im.src = src;
        im.alt = f.name;
        im.width = 800;
        im.height = 600;
        im.loading = 'lazy';
        im.decoding = 'async';
        media.appendChild(im);
      }
      var bodyEl = mk('div', 'ym-air-body');
      bodyEl.appendChild(mk('p', 'ym-air-name', f.name));
      if (f.tag) bodyEl.appendChild(mk('p', 'ym-air-tag', f.tag));
      var dl = mk('dl', 'ym-specs');
      row(dl, 'Seats', spec(f, 'Seats'));
      row(dl, 'Cruise', spec(f, 'Cruise'));
      row(dl, 'Useful Load', spec(f, 'Useful Load'));
      row(dl, 'Discovery Flight Weight Limit', weightLimit(f));
      row(dl, 'Rate', f.rate);
      row(dl, 'Package Rate', packageRate(f));
      bodyEl.appendChild(dl);
      var uses = mk('div', 'ym-air-uses');
      uses.appendChild(mk('p', 'ym-air-sub', 'Flown On'));
      var chips = mk('div', 'ym-chips');
      (f.courses || []).forEach(function (c) { if (safeHref(c[1])) chips.appendChild(chip(c[1], c[0])); });
      if (f.disc && f.disc !== MAIN) chips.appendChild(chip('/products/' + f.disc, f.discLabel + (f.discPrice ? ' · ' + f.discPrice : '')));
      uses.appendChild(chips);
      bodyEl.appendChild(uses);
      if (f.handle) {
        var more = mk('a', 'ym-more', 'More About The ' + f.name + ' →');
        more.setAttribute('href', '/pages/' + f.handle);
        bodyEl.appendChild(more);
      }
      panel.appendChild(media);
      panel.appendChild(bodyEl);
    }
    pick(start);
  }

  /* ------------------------------------------------------------------ calculator strip (first control) */
  function calcStrip() {
    qsa('[data-yfla-calc]').forEach(function (root) {
      if (root.hasAttribute('data-ym-calc')) return;
      var strip = root.querySelector('[data-yfc-strip]');
      var form = root.querySelector('form');
      var first = form && form.querySelector('select, input, textarea, button');
      if (!strip || !first) return;
      root.setAttribute('data-ym-calc', '1');
      var mq = window.matchMedia ? window.matchMedia('(max-width: 759px)') : null;
      var queued = false;
      function check() {
        queued = false;
        if (!mq || !mq.matches) { strip.classList.add('ym-strip-show'); return; }
        var line = window.innerHeight - (parseFloat(window.getComputedStyle(strip).bottom) || 0) - strip.offsetHeight;
        strip.classList.toggle('ym-strip-show', first.getBoundingClientRect().bottom <= line - 8);
      }
      function queue() {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(check);
      }
      document.addEventListener('scroll', queue, { passive: true, capture: true });
      window.addEventListener('resize', queue);
      check();
    });
  }

  /* ------------------------------------------------------------------ boot */
  var TYPES = {
    checklist: [checklist, /^(UL|OL)$/],
    hours: [hours, /^TABLE$/],
    steps: [steps, /^(OL|UL)$/],
    compare: [compare, /^TABLE$/],
    quiz: [quiz, /^(OL|UL)$/],
    aircraft: [aircraft, /^[A-Z]/]
  };
  function init(scope) {
    qsa('[data-yfla-mod]', scope || document).forEach(function (node) {
      if (node.hasAttribute('data-ym-ready')) return;
      var t = TYPES[node.getAttribute('data-yfla-mod')];
      if (!t || !t[1].test(node.tagName)) return;
      node.setAttribute('data-ym-ready', '1');
      try {
        t[0](node);
      } catch (err) {
        node.setAttribute('data-ym-ready', 'error');
        if (window.console && window.console.warn) window.console.warn('yfla-mods: ' + node.getAttribute('data-yfla-mod') + ' left as plain content', err);
      }
    });
    calcStrip();
  }
  M.init = init;

  var resizeTimer = 0;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      var top = stickyTop() + 'px';
      qsa('.ym-check').forEach(function (r) { r.style.setProperty('--ym-top', top); });
    }, 150);
  });

  function boot() {
    init(document);
    if (!('MutationObserver' in window)) return;
    var queued = false;
    new MutationObserver(function (muts) {
      if (queued) return;
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var a = added[j];
          if (a.nodeType !== 1) continue;
          if ((a.hasAttribute('data-yfla-mod') && !a.hasAttribute('data-ym-ready')) ||
              a.querySelector('[data-yfla-mod]:not([data-ym-ready])') || a.querySelector('[data-yfla-calc]:not([data-ym-calc])')) {
            queued = true;
            window.setTimeout(function () { queued = false; init(document); }, 0);
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();